export default "__VITE_ASSET__CCkn9MG6__"